import script from "./ModalErrorRedirect.vue?vue&type=script&setup=true&lang=js"
export * from "./ModalErrorRedirect.vue?vue&type=script&setup=true&lang=js"

import "./ModalErrorRedirect.vue?vue&type=style&index=0&id=19f93f36&scoped=true&lang=sass"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-19f93f36"]])

export default __exports__